import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import ReactGA from "react-ga";
import ScrollManager from "./components/ui/ScrollManager";

// Pages
import Home from "./pages/Home";
import PropertyDevelopment from "./pages/PropertyDevelopment";
import BuiltEnvironmentInvestments from "./pages/BuiltEnvironmentInvestments";
import InnovationVentures from "./pages/InnovationVentures";
import Approach from "./pages/Approach";
import About from "./pages/About";
import Contact from "./pages/Contact";
import SubmitOpportunity from "./pages/SubmitOpportunity";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import NotFound from "./pages/NotFound";

import "./i18n";

// Styles
import "./assets/scss/style.scss";
import "./assets/css/dddi-theme.css";
import "./assets/css/cy-ui.css";

const App = () => {
  useEffect(() => {
    ReactGA.set({ userId: "G-CC2486B96D" });
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  return (
    <Router>
      <ScrollManager>
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/property-development" exact component={PropertyDevelopment} />
          <Route path="/built-environment-investments" exact component={BuiltEnvironmentInvestments} />
          <Route path="/innovation-ventures" exact component={InnovationVentures} />
          <Route path="/approach" exact component={Approach} />
          <Route path="/about" exact component={About} />
          {/* `sensitive` so the legacy /Contact falls through to the redirect below.
              react-router v5 matches case-insensitively by default, which left
              /Contact serving the page at a second URL. */}
          <Route path="/contact" exact sensitive component={Contact} />
          <Route path="/submit-opportunity" exact component={SubmitOpportunity} />
          <Route path="/privacy" exact component={Privacy} />
          <Route path="/terms" exact component={Terms} />

          {/* Legacy redirects — old URLs keep working (06 §3.3). */}
          <Redirect from="/AboutUs" to="/about" />
          <Redirect from="/AboutScale" to="/about" />
          <Redirect from="/AboutPartner" to="/about" />
          <Redirect from="/AboutTeam" to="/about" />
          <Redirect from="/Service" to="/approach" />
          <Redirect from="/service" to="/approach" />
          <Redirect from="/FreeConsult" to="/submit-opportunity" />
          <Redirect from="/StaffRecruitment" to="/about" />
          <Redirect from="/CaseStudy" to="/about" />
          <Redirect from="/ProjectDevelopmentAndManagement" to="/property-development" />
          <Redirect from="/ExtensiveLandOldHouseRevitalization" to="/property-development" />
          <Redirect from="/PersonalRealInvestment" to="/approach" />
          <Redirect from="/InvestmentStructuralDesign" to="/approach" />
          <Redirect from="/PersonalHomeBuildingAdvice" to="/approach" />
          <Redirect from="/FirstHomeBuyers" to="/approach" />
          <Redirect from="/FinancePromise" to="/approach" />
          <Redirect from="/technologies" to="/about" />
          <Redirect from="/development" to="/about" />
          <Redirect from="/Contact" to="/contact" />

          {/* Retired content sources (template / Lorem Ipsum) fall through to 404. */}
          <Route component={NotFound} />
        </Switch>
      </ScrollManager>
    </Router>
  );
};

export default App;
